import { InjectedIntlProps, injectIntl } from 'react-intl'

import ActionIcon from '@components/UI/ActionIcon'
import { useModal } from '@hooks/useModal'
import Theme from '@theme'
import { PitchComparisonModal } from './PitchComparisonModal'

interface IProps {
  highlighted?: boolean
  submissionId: number
  campaignId: number
}

export const ActionBarIconCompareSubmission = ({
  highlighted,
  intl,
  submissionId,
  campaignId,
}: IProps & InjectedIntlProps) => {
  const { showModal } = useModal()
  const onClick = () => {
    showModal(PitchComparisonModal, { submissionId, campaignId })
  }
  return (
    <ActionIcon
      highlighted={highlighted}
      glyph="compare-submission"
      color={Theme.grey900Color}
      size={1.5}
      tooltip={intl.formatMessage({ id: 'submission.card.action.compareSubmission' })}
      elementName="compare"
      onClick={onClick}
    />
  )
}

export default injectIntl(ActionBarIconCompareSubmission)
